import React from 'react';
import HubScreen from './HubScreen';
import Pipeline from './Pipeline';
import Coverage from './Coverage';
import CoveragePlanner from './CoveragePlanner';
import Geocoding from './Geocoding';
import SyncTrigger from './SyncTrigger';

const TABS = [
  { id: 'pipeline', label: 'Pipeline', Component: Pipeline },
  { id: 'coverage', label: 'Coverage', Component: Coverage },
  { id: 'coverageplanner', label: 'Coverage Planner', Component: CoveragePlanner },
  { id: 'geocoding', label: 'Geocoding', Component: Geocoding },
  { id: 'synctrigger', label: 'Sync Trigger', Component: SyncTrigger },
];

export default function PipelineHub(props) {
  return <HubScreen tabs={TABS} hubId="pipeline" passProps={props} />;
}
